import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Avatar,
  SvgIcon,
  IconButton,
  withWidth
} from '@material-ui/core';

import { ReactComponent as FacebookIcon } from '../../images/Icons/facebook.svg';
import { ReactComponent as WhatsAppIcon } from '../../images/Icons/whatsapp-01.svg';
import { ReactComponent as TwitterIcon } from '../../images/Icons/twitter.svg';
import { ReactComponent as MailIcon } from '../../images/Icons/mail.svg';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    textAlign: 'center'
  },
  social: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(1, 0, 1, 0),
    cursor: 'pointer'
  },
  socialAvatar: {
    backgroundColor: '#707070',
    marginRight: theme.spacing(1),
    height: '1.5rem',
    width: '1.5rem',
    '& > svg': {
      width: '15px'
    }
  },
  socialText: {
    textDecoration: 'unset',
    color: '#000000'
  },
  socialButton: {
    padding: 0,
    transition: 'all .2 ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  }
});

const ShareToSocialMenu = withStyles(styles)(
  ({ classes, path, isOwner, openMailDialog, type, width }) => {
    let ownerText;
    let viewerText;
    if (type === 'Dresser') {
      ownerText = 'Mirá+los+productos+que+subí+en+mi+vestidor!';
      viewerText = 'Mirá+el+vestidor+que+encontré!';
    } else if (type === 'Product') {
      ownerText = 'Mirá+el+producto+que+vendo+en+Renová+Tu+Vestidor!';
      viewerText = 'Mirá+la+oferta+que+encontré+en+Renová+Tu+Vestidor!';
    }
    const WHATSAPP_SHARE_URL =
      width === 'xs' || width === 'sm' ? 'whatsapp://' : 'https://wa.me/';

    return (
      <div className={classes.root}>
        <Typography
          style={{
            width: '100%',
            color: '#707070',
            fontWeight: 600,
            fontSize: '0.9rem',
            textAlign: 'center'
          }}
        >
          Compartir en:
        </Typography>
        <div className={classes.social}>
          <Avatar
            className={classes.socialAvatar}
            component="a"
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?display=page&quote=${
              isOwner ? ownerText : viewerText
            }&u=${window.encodeURIComponent(
              `${process.env.REACT_APP_WEB_URL}${path}`
            )}`}
          >
            <SvgIcon>
              <FacebookIcon />
            </SvgIcon>
          </Avatar>
          <Typography
            className={classes.socialText}
            component="a"
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?display=page&quote=${
              isOwner ? ownerText : viewerText
            }&u=${window.encodeURIComponent(
              `${process.env.REACT_APP_WEB_URL}${path}`
            )}`}
          >
            Facebook
          </Typography>
        </div>
        <div className={classes.social}>
          <Avatar
            className={classes.socialAvatar}
            component="a"
            target="_blank"
            href={`${WHATSAPP_SHARE_URL}send?text=${
              isOwner ? ownerText : viewerText
            }+${window.encodeURIComponent(
              `${process.env.REACT_APP_WEB_URL}${path}`
            )}`}
            data-action="share/whatsapp/share"
          >
            <SvgIcon>
              <WhatsAppIcon />
            </SvgIcon>
          </Avatar>
          <Typography
            className={classes.socialText}
            component="a"
            target="_blank"
            href={`${WHATSAPP_SHARE_URL}send?text=${
              isOwner ? ownerText : viewerText
            }+${window.encodeURIComponent(
              `${process.env.REACT_APP_WEB_URL}${path}`
            )}`}
            data-action="share/whatsapp/share"
          >
            WhatsApp
          </Typography>
        </div>
        <div className={classes.social}>
          <Avatar
            className={classes.socialAvatar}
            component="a"
            target="_blank"
            href={`https://twitter.com/intent/tweet?text=${
              isOwner ? ownerText : viewerText
            }&url=${window.encodeURIComponent(
              `${process.env.REACT_APP_WEB_URL}${path}`
            )}`}
          >
            <SvgIcon>
              <TwitterIcon />
            </SvgIcon>
          </Avatar>
          <Typography
            className={classes.socialText}
            component="a"
            target="_blank"
            href={`https://twitter.com/intent/tweet?text=${
              isOwner ? ownerText : viewerText
            }&url=${window.encodeURIComponent(
              `${process.env.REACT_APP_WEB_URL}${path}`
            )}`}
          >
            Twitter
          </Typography>
        </div>
        <div className={classes.social}>
          <IconButton
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              openMailDialog();
            }}
            className={classes.socialButton}
          >
            <Avatar className={classes.socialAvatar}>
              <SvgIcon>
                <MailIcon />
              </SvgIcon>
            </Avatar>
          </IconButton>
          <Typography
            className={classes.socialText}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              openMailDialog();
            }}
          >
            Mail
          </Typography>
        </div>
      </div>
    );
  }
);

export default withWidth()(ShareToSocialMenu);
